import React from 'react'
import styled from 'styled-components'
import { Card, Flex, Hide, Text } from 'pcln-design-system'
import constants from './constants'
import { WebPBackgroundImage } from '@pcln/content-tile'

const Wrapper = styled(Card)`
  height: 340px;
  ${props => props.theme.mediaQueries[3]} {
    height: 250px;
  }
  background-color: white;
  border-radius: 4px;
`

const FlexWithTopBorder = styled(Flex)`
  border-top: 6px solid ${props => props.theme.colors.blue};
  height: 100%;
  border-radius: 3px;
`

const Headline = styled(Text)`
  font-size: 32px;
  line-height: 36px;
`

const ImageOnRightWebP = styled(WebPBackgroundImage)`
  align-self: flex-start;
  height: 100%;
  object-fit: cover;
  object-position: -40px;
  position: relative;
  border-bottom-right-radius: 3px;
  right: 0;
  background-color: #fff;
`

const ImageOnTopWebP = styled(WebPBackgroundImage)`
  width: 100%;
  flex-shrink: 0;
  object-fit: cover;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background-color: #fff;
`

const TextWrapper = styled(Flex)`
  height: 210px;
  width: 100%;
  ${props => props.theme.mediaQueries[3]} {
    height: 240px;
  }
`

const KaleyAdBox = () => (
  <Wrapper boxShadowSize='md' mx={2} width={['30%', null, null, null, '400px']}>
    <FlexWithTopBorder flexDirection={['column', null, null, null, 'row']}>
      <Hide xl xxl>
        <ImageOnTopWebP
          height='115px'
          image={constants.hotel.tablet.image}
          imageWebP={constants.hotel.tablet.imageWebP}
        />
      </Hide>
      <TextWrapper flexDirection='column' p={3}>
        <Headline mt='-6px' color='primary' fontWeight='bold'>10% off<Headline.span color='text' fontWeight='bold'> coupon</Headline.span></Headline>
        <Text fontSize={1} mt={2} style={{ lineHeight: '24px' }}>
          {constants.hotel.text}
        </Text>
        <Text fontSize='11px' mt={[20, null, null, 'auto']}>{constants.hotel.smallPrint}</Text>
      </TextWrapper>
      <Hide xs sm md lg width={1}>
        <ImageOnRightWebP
          height='100%'
          image={constants.hotel.desktop.image}
          imageWebP={constants.hotel.desktop.impageWebP}
        />
      </Hide>
    </FlexWithTopBorder>
  </Wrapper>
)

KaleyAdBox.displayName = 'KaleyAdBox'

export default KaleyAdBox
